import styles from "./InfoPage.module.scss"; // Імпортуємо SCSS файл для стилів
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import CookiePopupButton from "@/components/CookieBanner/CookiePopupButton.tsx";
import { useEffect } from "react";

const Impressum = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);
  return (
    <div>
      <title>Impressum – HIXA – DSG Getriebe Reparatur & Wartung</title>
      <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      <Nav />
      <h2 className={` sectionContainer ${styles.title}`}>Impressum</h2>
      <div className="container sectionContainer sectionContainerWhite">
        <p className={styles.infoPageDate}>Angaben gemäß § 5 TMG:</p>

        <p className={styles.infoPageText}>
          Gesetzliche Anbieterkennung:
          <br />
          HIXA GmbH
          <br />
          Neukirchstraße 74,
          <br />
          13089 Berlin
          <br />
          vertr. d. d. Geschäftsführer: Anna Likhnenko
          <br />
          Telefon: +49 30 520 151 91
          <br />
          E-Mail: kunden@hixa.eu
        </p>

        <p className={styles.infoPageText}>
          Instagram, WhatsApp, WhatsApp Business, Telegram, Viber, Facebook,
          Messenger, Google
        </p>

        <p className={styles.infoPageText}>
          eingetragen im Handelsregister des Amtsgerichtes 14057 Charlottenburg
          (Berlin)
          <br />
          Handelsregisternummer HRB 247686 B
          <br />
          Umsatzsteuer-Identifikationsnummer: DE361951053
        </p>

        <p className={styles.infoPageText}>Alternative Streitbeilegung:</p>

        <p className={styles.infoPageText}>
          Die Europäische Kommission stellt eine Plattform für die
          außergerichtliche Online-Streitbeilegung (OS-Plattform) bereit,
          aufrufbar unter{" "}
          <a
            href="https://ec.europa.eu/odr"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ec.europa.eu/odr
          </a>
          .
        </p>

        <p className={styles.infoPageText}>
          Wir sind nicht bereit und nicht verpflichtet, an
          Streitbeilegungsverfahren vor Verbraucherschlichtungsstellen
          teilzunehmen.
        </p>
      </div>
      <CookiePopupButton></CookiePopupButton>
      <Footer />
    </div>
  );
};

export default Impressum;
